module.exports = __webpack_public_path__ + "static/media/book-now.3fd3eb62.png";